import React, { useEffect, useState } from "react";
import { Button, Form, Checkbox, Steps, message, Modal, Row, Col, Input, Upload, Divider, Spin } from "antd";
import { trans, InputText, InputDate, AddNewButton, InputCheck, SelectResourceList, InputTextArea } from "@comps/components";
import { makeRequest, makeRequestStateless, getErrorProps } from "@utils/helpers";
import { createSelectList, createRelationshipsList } from '@comps/commonFunctions';
import { ModalComponent, SelectWithSearch } from "@comps/components"
import { Commons } from "../../constants";

import {
  createEmployeeReq,
  getEmployeeRelatedDataReq,
  getCompanyRelatedDataReq,
  getBranchsByLocationIdReq,
  matchCnicReq
} from "../requests";

import { Const } from '../../constants';
import CreateGrade from "../../../organizationManagement/grades/components/CreateGrade";
import CreateLocation from '../../../organizationManagement/locations/components/CreateLocation';
import CreateDepartment from '../../../organizationManagement/departments/components/CreateDepartment';
import CreateBranch from '../../../organizationManagement/branches/components/CreateBranch';
import CreateDesignation from '../../../organizationManagement/designations/components/CreateDesignation';
import CreateJobTitle from '../../../organizationManagement/jobTitles/components/CreateJobTitle';
import "./Employee.css"
import CreatePayroll from "../../../payrollManagement/payrolls/CreatePayroll";
import { getAllcountriesReq, getStatesByCountryReq, getCitiesByStateReq } from "@mods/common/requests"
import { getRelationShips } from "../../../common/requests";
import { CheckCircleFilled, CloseOutlined, DeleteOutlined, EyeOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import CryptoJS from "crypto-js";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { employeeTooltips } from "../../common/employeeTooltips";
const langKey = Const["employee"].lngKey
const fieldLabel = makeFieldLabel(employeeTooltips.profile, { namespace: "profile", label: (key) => trans(`${langKey}.${key}`) });
const createEmployee = "createEmployee";
const createEmployment = "createEmployment";
const createUser = "createUser";
const SELECT_PLACEHOLDER = "Select";
const renderRequiredMark = (label, { required }) => (
  <>
    { label }
    { required && <span className="create-employee-required-mark" aria-hidden="true">*</span> }
  </>
);

const DRAFT_SECRET = "klok-create-employee-draft";
const DATE_FIELDS = new Set([
  "d_o_b", "cnic_expiry_date", "passport_expiry_date",
  "driving_license_expiry_date", "joining_date", "contract_expiry_date",
  "from_date", "to_date"
]);
const EXCLUDED_DRAFT_FIELDS = new Set([
  "password", "profile_pic", "cnic_attachment",
  "passport_attachment", "driving_license_attachment", "degree_attachment"
]);

const getDraftKey = () =>
  `klok:create-employee:${localStorage.getItem("tenant") || "tenant"}:${localStorage.getItem("company_id") || "company"}`;

const sanitizeDraftValues = (value) => {
  if (dayjs.isDayjs(value)) {
    return { __klokDate: value.toISOString() };
  }
  if (Array.isArray(value)) {
    return value.map(sanitizeDraftValues);
  }
  if (value && typeof value === "object") {
    return Object.entries(value).reduce((result, [key, item]) => {
      if (!EXCLUDED_DRAFT_FIELDS.has(key) && !(typeof File !== "undefined" && item instanceof File)) {
        result[key] = sanitizeDraftValues(item);
      }
      return result;
    }, {});
  }
  return value;
};

const reviveDraftValues = (value, key = "") => {
  if (value && value.__klokDate) {
    return dayjs(value.__klokDate);
  }
  if (Array.isArray(value)) {
    return value.map((item) => reviveDraftValues(item));
  }
  if (value && typeof value === "object") {
    return Object.entries(value).reduce((result, [field, item]) => {
      result[field] = DATE_FIELDS.has(field) && typeof item === "string"
        ? dayjs(item)
        : reviveDraftValues(item, field);
      return result;
    }, {});
  }
  return DATE_FIELDS.has(key) && typeof value === "string" ? dayjs(value) : value;
};

const hasMeaningfulDraftValue = (value) => {
  if (dayjs.isDayjs(value)) return true;
  if (Array.isArray(value)) return value.some(hasMeaningfulDraftValue);
  if (value && typeof value === "object") {
    return Object.entries(value).some(
      ([key, item]) => !EXCLUDED_DRAFT_FIELDS.has(key) && hasMeaningfulDraftValue(item)
    );
  }
  return value === true || typeof value === "number" || (typeof value === "string" && value.trim() !== "");
};

const readEmployeeDraft = () => {
  try {
    const encrypted = localStorage.getItem(getDraftKey());
    if (!encrypted) return null;
    const bytes = CryptoJS.AES.decrypt(encrypted, DRAFT_SECRET);
    const text = bytes.toString(CryptoJS.enc.Utf8);
    return text ? reviveDraftValues(JSON.parse(text)) : null;
  } catch (error) {
    console.error("Unable to restore Create Employee draft", error);
    localStorage.removeItem(getDraftKey());
    return null;
  }
};

const AddEmployee = (props) => {

  const restoredDraft = React.useMemo(readEmployeeDraft, []);
  const [employeeFormInstance] = Form.useForm()
  const [employmentForm] = Form.useForm()
  const [salaryForm] = Form.useForm()
  const [userFormInstance] = Form.useForm()
  const [othersForm] = Form.useForm();
  const [addressForm] = Form.useForm()
  const [contactForm] = Form.useForm();
  const [educationForm] = Form.useForm();
  const [relativesForm] = Form.useForm()
  const [closePromptOpen, setClosePromptOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [employeeDataLoading, setEmployeeDataLoading] = useState(true);
  const [companyDataLoading, setCompanyDataLoading] = useState(true);
  const [selectedNationality, setSelectedNationality] = useState(restoredDraft?.selectedNationality ?? 166)
  const [isFinalAuthority, setIsFinalAuthority] = useState(restoredDraft?.isFinalAuthority ?? false)
  const [isProbation, setIsProbation] = useState(restoredDraft?.isProbation ?? false)

  const [errors, setErrors] = useState([]);
  const [timezone, setTimezones] = useState([]);
  const [salutations, setSalutations] = useState([]);
  const [martialstatuses, setMartialstatuses] = useState([]);
  const [religions, setReligions] = useState([]);
  const [genders, setGenders] = useState([]);
  const [bloodgroups, setBloodgroups] = useState([]);
  const [nationalities, setNationalities] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [employmentTypes, setEmploymentTypes] = useState([]);

  const [designations, setDesignations] = useState([]);
  const [locations, setLocations] = useState([]);
  const [branches, setBranches] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [grades, setGrades] = useState([]);
  const [lineManagers, setLineManagers] = useState([]);
  const [finalAuthorities, setFinalAuthorities] = useState([]);
  const [jobTitles, setJobTitles] = useState([]);
  const [roles, setRoles] = useState([]);
  const [isEmploymentType, setIsEmploymentType] = useState(restoredDraft?.isEmploymentType);
  const [saveloader, setsaveloader] = useState(false)
  const [payrolls, setPayrolls] = useState([]);
  const [paymentmethods, setPaymentmethods] = useState([]);
  const [policies, setPolicies] = useState([])
  const [ispaymentMethod, setisPaymentMethod] = useState(restoredDraft?.ispaymentMethod)
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [addressInfo, setAddressInfo] = useState(restoredDraft?.forms?.address)
  const [contactInfo, setContactInfo] = useState(restoredDraft?.forms?.contact)
  const [educationInfo, setEducationInfo] = useState(restoredDraft?.forms?.education);
  const [relativesInfo, setRelativesInfo] = useState(restoredDraft?.forms?.relatives?.relatives || []);
  const [relationships, setRelationships] = useState([]);
  const [isDegreeCompleted, setIsDegreeCompleted] = useState(restoredDraft?.isDegreeCompleted ?? false);
  const [hasAddress, setHasAddress] = useState(restoredDraft?.hasAddress ?? false);
  const [hasContact, setHasContact] = useState(restoredDraft?.hasContact ?? false);
  const [hasEducation, setHasEducation] = useState(restoredDraft?.hasEducation ?? false);
  const [hasRelative, setHasRelative] = useState(restoredDraft?.hasRelative ?? false);
  const [skipSalary, setSkipSalary] = useState(restoredDraft?.skipSalary ?? false);

  const salaryTypes = [
    {
      value: 'monthly',
      label: 'Monthly',
    },
    {
      value: 'daily',
      label: 'Daily Wages',
    },
    {
      value: 'hourly',
      label: 'Hourly',
    },
  ]
  const [childComponent, setChildComponent] = useState(null);
  useEffect(() => {
    getRemoteData();
    getCompanyRelatedData();

  }, []);

  const getRemoteData = () => {
    setsaveloader(false)
    makeRequestStateless(getEmployeeRelatedDataReq, false, onEmployeeRelatedDataSuccess, onEmployeeRelatedDataError)
    makeRequestStateless(getAllcountriesReq, false, onGetCountries, false)
    makeRequestStateless(getRelationShips, false, onGetRelationShips, false)
  }
  const onGetRelationShips = (response) => {
    setRelationships(createRelationshipsList(response.relationships))
    //setContactTypes(createSelectList(response.contact_types))
  }
  const onGetCountries = (response) => {
    setCountries(createSelectList(response.countries))
  }
  const onEmployeeRelatedDataSuccess = (data, res) => {
    setEmployeeDataLoading(false)
    setSalutations(createSelectList(data.salutations))
    setNationalities(createSelectList(data.countries))
    setBloodgroups(createSelectList(data.bloodgroups))
    setGenders(createSelectList(data.genders))
    setReligions(createSelectList(data.religions))
    setBloodgroups(createSelectList(data.bloodgroups))
    setMartialstatuses(createSelectList(data.maritalstatuses
    ))
    setPayrolls(createSelectList(data.payrolls
    ))
    setPaymentmethods(createSelectList(data.payment_methods
    ))
    setPolicies(createSelectList(data.policies
    ))

  }

  const onEmployeeRelatedDataError = (err) => {
    setEmployeeDataLoading(false)
    console.error(err)
  }

  const getCompanyRelatedData = () => {
    makeRequestStateless(getCompanyRelatedDataReq, false, onCompanyRelatedDataSuccess, onCompanyRelatedDataError);
  }

  const onCompanyRelatedDataSuccess = (data, res) => {
    setCompanyDataLoading(false)
    setGrades(createSelectList(data.grades));
    setLocations(createSelectList(data.locations));
    setDepartments(createSelectList(data.departments));
    setDesignations(createSelectList(data.designations));
    setLineManagers(createSelectList(data.line_managers));
    setFinalAuthorities(createSelectList(data.final_authorities));
    setRoles(createSelectList(data.roles));
    setEmployeeTypes(createSelectList(data.employee_types))
    setEmploymentTypes(createSelectList(data.contract_types))
    setJobTitles(createSelectList(data.job_titles))
    setTimezones(createSelectList(data.time_zones))
  }
  const onCompanyRelatedDataError = (error, res) => {
    setCompanyDataLoading(false)
  }
  //------------on submit forms----------------
  const onSubmitFirstStep = (data) => {
    setCurrent(currentStep + 1)
    if (data) {
      // data.d_o_b=data.d_o_b.format('YYYY-MM-DD');
      data.cnic_attachment = cnicFileList.length > 0 && cnicFileList[0].id === undefined ? cnicFileList[0].originFileObj : null
      data.driving_license_attachment = drivingLicenseFileList.length > 0 && drivingLicenseFileList[0].id === undefined ? drivingLicenseFileList[0].originFileObj : null
      data.passport_attachment = passportFileList.length > 0 && passportFileList[0].id === undefined ? passportFileList[0].originFileObj : null
    }
    setEmployeeInfo(data)
  }

  const onSubmitEmployment = (data) => {
    if (isFinalAuthority) {
      data.is_hod = isFinalAuthority;
      data.is_manager = isFinalAuthority;
    }
    if (data) {
      // data.joining_date=data.joining_date.format('YYYY-MM-DD');
    }
    setEmploymentInfo(data)
    setCurrent(currentStep + 1)
  }

  const onSubmitSalary = (data) => {
    setSalaryInfo(data)
    if (data) {
      setCurrent(currentStep + 1)
    }

  }

  const onSubmitUser = (data) => {
    setUserInfo(data)
    if (data) {
      setCurrent(currentStep + 1);
    }
  }


  const isDisabled = (data) => {
    let res = false;
    const address = addressForm.getFieldsValue();
    const contact = contactForm.getFieldsValue();
    const education = educationForm.getFieldsValue();
    const relatives = relativesForm.getFieldValue('relatives');

    if (hasAddress) {
      if (!address.address_type || !address.complete_address) {
        message.error('please fill the mandatory address info!')
        res = true;
      }
    }

    if (hasContact) {
      if (!contact.contact_type || !contact.name || !contact.relationship || !contact.mobile_no) {
        message.error('please fill the mandatory contact info!')
        res = true;
      }
    }

    if (hasEducation) {
      if (!education.institute_name || !education.degree) {
        message.error('please fill the mandatory education info!')
        res = true;
      }
      if (education.is_degree_completed) {
        message.error('please fill the mandatory education info!')
        res = true;
      }
    }


    return res;
  }


  const onSaveAllData = (data) => {

    let disabled = isDisabled(data);
    if (disabled) {
      return;
    }

    const address = addressForm.getFieldsValue();
    const contact = contactForm.getFieldsValue();
    const education = educationForm.getFieldsValue();

    const relatives = relativesForm.getFieldValue('relatives');
    setRelativesInfo(relatives)

    //relatives
    const relativesData = [];
    if (hasRelative && relatives.length > 0) {
      relatives.forEach(each => {
        if (each) {
          if (!each.relationship || !each.name || !each.phone_no) {
            message.error('please fill the mandatory Relatives info!')
            disabled = true;
          }
          relativesData.push(each);
        }
      })
    }

    if (disabled) {
      return;
    }


    setAddressInfo(address);
    setContactInfo(contact);
    setEducationInfo(education);

    if (employeeInfo.profile_pic && employeeInfo.profile_pic.file) {
      employeeInfo.profile_pic = employeeInfo.profile_pic.file;
    }

    employeeInfo.d_o_b = dayjs(employeeInfo.d_o_b).format('YYYY-MM-DD');
    employmentInfo.joining_date = dayjs(employmentInfo.joining_date).format('YYYY-MM-DD');
    let payload = { employee_info: employeeInfo, employment_info: employmentInfo, user_info: userInfo, payroll_info: !skipSalary ? salaryInfo : null, address_info: hasAddress ? address : null, contact_info: hasContact ? contact : null, education_info: hasEducation ? education : null, relatives_info: relativesData }
    makeRequest(setLoader, createEmployeeReq, payload, onEmployeeCreateSuccess, onEmployeeCreateError);
    setsaveloader(true)
  }

  const onEmployeeCreateSuccess = (response) => {
    setsaveloader(false)
    clearEmployeeDraft()
    message.success('Employee Created Successfully!')
    props.onCompleted(response)
  }
  const onEmployeeCreateError = (error, res) => {
    setsaveloader(false)
    if (res.response.data.message.email) {
      setCurrent(currentStep - 1)
      setErrors({
        username: res.response.data.message.email
      })
      message.error(res.response.data.message.email)
    } else {
      message.error(res.response.data.message)
    }
  }

  //-----------------onChange--------------------
  const onChangeLocation = (locationId) => {
    if (locationId) {
      makeRequestStateless(getBranchsByLocationIdReq, locationId, onBranchsByLocationIdSuccess, onCompanyRelatedDataError);
    }
    else {
      setBranches([]);
    }
  }
  const onBranchsByLocationIdSuccess = (data) => {
    setBranches(createSelectList(data));
  }

  const onChangeNationality = (data) => {
    setSelectedNationality(data)
  }

  const onChangeIsFinalAuthority = (e) => {
    setIsFinalAuthority(e.target.checked);
  };
  const onChangeProbation = (e) => {
    setIsProbation(e.target.checked);
  }
  const onChangeCnic = (e) => {
    let count = e.target.value.toString().length;
    if (count > 12) {
      makeRequestStateless(matchCnicReq, e.target.value, onMatchCnicSuccess, onMatchCnicError);
    }

  }
  const onMatchCnicSuccess = (response) => {
    if (response.result) {
      message.error('Cnic matched with another employee in the system.!')
    }
  }
  const onMatchCnicError = (response) => {

  }
  const onChangeEmploymentType = (id) => {
    setIsEmploymentType(id);
  }
  //-------------------end--------------------
  //---------------------form layout------------

  //============uploading file============
  //const [fileList, setFileList] = useState([]);
  const [profilePicFileList, setprofilePicFileList] = useState([]);
  const [cnicFileList, setcnicFileList] = useState([]);
  const [passportFileList, setpassportFileList] = useState([]);
  const [drivingLicenseFileList, setdrivingLicenseFileList] = useState([]);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const handleCancel = () => setPreviewOpen(false);
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const onChangeProfilePic = ({ fileList: newFileList }) => {
    setprofilePicFileList(newFileList);
  };
  const onPreview = async (file) => {
    const extension = String(file.extension || file.name?.split('.').pop() || '').toLowerCase();
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension) || String(file.type || '').startsWith('image/');
    const isPdf = extension === 'pdf' || file.type === 'application/pdf';

    if (file.url && (!isImage || isPdf)) {
      window.open(file.url, '_blank');
      return;
    }

    if (isPdf && file.originFileObj) {
      window.open(URL.createObjectURL(file.originFileObj), '_blank');
      return;
    }

    if (!isImage && file.originFileObj) {
      window.open(URL.createObjectURL(file.originFileObj), '_blank');
      return;
    }

    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    //setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };
  const getAttachmentFileName = (fileList) => {
    const file = fileList?.[0];
    return file?.name || file?.org_name || file?.url?.split('/').pop() || "Done";
  };
  const openAttachmentInNewTab = (file) => {
    if (!file) return;

    if (file.url) {
      window.open(file.url, '_blank');
      return;
    }

    if (file.originFileObj) {
      window.open(URL.createObjectURL(file.originFileObj), '_blank');
    }
  };
  const renderDocumentAttachment = ({ name, label, fileList, setFileList }) => {
    const isUploaded = fileList.length > 0;
    const selectedFile = fileList[0];

    return (
      <Form.Item name={ name } noStyle>
        <Upload
          accept=".pdf,.jpg,.png,.jpeg"
          className="create-employee-attachment-chip-upload"
          fileList={ fileList }
          onChange={ ({ fileList: newFileList }) => setFileList(newFileList) }
          onPreview={ onPreview }
          showUploadList={ false }
          maxCount={ 1 }
          multiple={ false }
          beforeUpload={ () => false }
        >
          <div
            role="button"
            tabIndex={ 0 }
            className={ [
              "create-employee-attachment-chip",
              isUploaded ? "create-employee-attachment-chip--done" : ""
            ].filter(Boolean).join(" ") }
            aria-label={ `${label} attachment ${isUploaded ? "uploaded" : "not uploaded"}` }
          >
            <span className="create-employee-attachment-chip__icon">
              { isUploaded ? <CheckCircleFilled /> : null }
            </span>
            <span className="create-employee-attachment-chip__copy">
              <span className="create-employee-attachment-chip__label">{ label }</span>
              <span className="create-employee-attachment-chip__status">
                { isUploaded ? getAttachmentFileName(fileList) : "Attach file" }
              </span>
            </span>
            <span className="create-employee-attachment-chip__action">
              { isUploaded ? (
                <>
                  <span>Done</span>
                  <button
                    type="button"
                    className="create-employee-attachment-chip__view"
                    aria-label={ `View ${label} attachment` }
                    title={ `View ${label}` }
                    onClick={ (event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      openAttachmentInNewTab(selectedFile);
                    } }
                  >
                    <EyeOutlined />
                  </button>
                  <button
                    type="button"
                    className="create-employee-attachment-chip__remove"
                    aria-label={ `Remove ${label} attachment` }
                    onClick={ (event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      setFileList([]);
                    } }
                  >
                    <CloseOutlined />
                  </button>
                </>
              ) : "Upload" }
            </span>
          </div>
        </Upload>
      </Form.Item>
    );
  };
  //=========================================
  //------------------------------------
  //------------current step---------
  const [employeeInfo, setEmployeeInfo] = useState(restoredDraft?.forms?.employee);
  const [employmentInfo, setEmploymentInfo] = useState(restoredDraft?.forms?.employment);
  const [salaryInfo, setSalaryInfo] = useState(restoredDraft?.forms?.salary);
  const [userInfo, setUserInfo] = useState();
  const [currentStep, setCurrent] = useState(
    restoredDraft ? Math.min(restoredDraft.currentStep ?? 0, 3) : 0
  );

  const clearEmployeeDraft = () => localStorage.removeItem(getDraftKey());

  const persistEmployeeDraft = () => {
    window.setTimeout(() => {
      const userValues = { ...userFormInstance.getFieldsValue(true) };
      delete userValues.password;

      const draft = sanitizeDraftValues({
        currentStep,
        selectedNationality,
        isFinalAuthority,
        isProbation,
        isEmploymentType,
        ispaymentMethod,
        isDegreeCompleted,
        hasAddress,
        hasContact,
        hasEducation,
        hasRelative,
        skipSalary,
        forms: {
          employee: { ...employeeInfo, ...employeeFormInstance.getFieldsValue(true) },
          employment: { ...employmentInfo, ...employmentForm.getFieldsValue(true) },
          salary: { ...salaryInfo, ...salaryForm.getFieldsValue(true) },
          user: { ...userInfo, ...userValues },
          others: othersForm.getFieldsValue(true),
          address: { ...addressInfo, ...addressForm.getFieldsValue(true) },
          contact: { ...contactInfo, ...contactForm.getFieldsValue(true) },
          education: { ...educationInfo, ...educationForm.getFieldsValue(true) },
          relatives: relativesForm.getFieldsValue(true)
        }
      });
      const encrypted = CryptoJS.AES.encrypt(JSON.stringify(draft), DRAFT_SECRET).toString();
      localStorage.setItem(getDraftKey(), encrypted);
    }, 0);
  };

  useEffect(() => {
    if (!restoredDraft?.forms) return;
    employeeFormInstance.setFieldsValue(restoredDraft.forms.employee);
    employmentForm.setFieldsValue(restoredDraft.forms.employment);
    salaryForm.setFieldsValue(restoredDraft.forms.salary);
    userFormInstance.setFieldsValue(restoredDraft.forms.user);
    othersForm.setFieldsValue(restoredDraft.forms.others);
    addressForm.setFieldsValue(restoredDraft.forms.address);
    contactForm.setFieldsValue(restoredDraft.forms.contact);
    educationForm.setFieldsValue(restoredDraft.forms.education);
    relativesForm.setFieldsValue(restoredDraft.forms.relatives);
  }, []);

  useEffect(() => {
    if (restoredDraft || employeeInfo || employmentInfo || salaryInfo || userInfo) {
      persistEmployeeDraft();
    }
  }, [
    currentStep, selectedNationality, isFinalAuthority, isProbation,
    isEmploymentType, ispaymentMethod, isDegreeCompleted, hasAddress,
    hasContact, hasEducation, hasRelative, skipSalary
  ]);

  const closeCreateEmployee = (discardDraft = false) => {
    if (discardDraft) clearEmployeeDraft();
    else persistEmployeeDraft();
    setClosePromptOpen(false);
    props.onCompleted(false);
  };

  const requestCloseCreateEmployee = () => {
    const enteredValues = [
      employeeFormInstance, employmentForm, salaryForm, userFormInstance,
      othersForm, addressForm, contactForm, educationForm, relativesForm
    ].map((form) => form.getFieldsValue(true));

    if (!enteredValues.some(hasMeaningfulDraftValue)) {
      clearEmployeeDraft();
      props.onCompleted(false);
      return;
    }
    setClosePromptOpen(true);
  };


  const employeeForm = () => {
    return (
      <>
        <Form
          // { ...formLayout }
          layout="vertical"
          requiredMark={ renderRequiredMark }
          name={ createEmployee }
          id={ createEmployee }
          initialValues={ employeeInfo }
          form={ employeeFormInstance }
          onValuesChange={ persistEmployeeDraft }
          onFinish={ onSubmitFirstStep }
          scrollToFirstError
        >
          <div className="employee-data"><h5 className="employee-data-style">Personal Information</h5></div>
          <div style={ { paddingTop: 25 } }>
            <Row gutter={ 20 }>


              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="salutation_id" label={ fieldLabel("salutation_id", trans(`${langKey}.selectSalutation`)) } rules={ rules.salutation_id } className="da-mb-16"
                  { ...getErrorProps(errors['salutation_id']) }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ salutations }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="first_name" rules={ rules.first_name } label={ fieldLabel("first_name", trans(`${langKey}.firstName`)) } className="da-mb-16"
                  { ...getErrorProps(errors['first_name']) } size="small"
                >
                  <InputText placeholder="First name" />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="middle_name" rules={ rules.middle_name } label={ fieldLabel("middle_name", trans(`${langKey}.middleName`)) } className="da-mb-16"
                  { ...getErrorProps(errors['middle_name']) } size="small"
                >
                  <InputText placeholder="Middle name" />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="last_name" rules={ rules.last_name } label={ fieldLabel("last_name", trans(`${langKey}.lastName`)) } className="da-mb-16"
                  { ...getErrorProps(errors['last_name']) } size="small"
                >
                  <InputText placeholder="Last name" />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="father_or_husband_name" rules={ rules.father_or_husband_name } label={ fieldLabel("father_or_husband_name", "Father / Husband Name") } className="da-mb-16"
                  { ...getErrorProps(errors['name']) } size="small"
                >
                  <InputText placeholder="Name" />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="gender_id" label={ fieldLabel("gender_id", trans(`${langKey}.selectGender`)) } rules={ rules.gender_id } className="da-mb-16"
                  { ...getErrorProps(errors['gender_id']) }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ genders }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="d_o_b" rules={ rules.d_o_b } label={ fieldLabel("d_o_b", "Date of Birth") } className="da-mb-16"
                  { ...getErrorProps(errors['d_o_b']) } size="small"
                >
                  <InputDate
                    format="DD-MMM-YYYY" />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item
                  name="marital_status_id" label={ fieldLabel("marital_status_id", trans(`${langKey}.selectMartialStatus`)) } rules={ rules.marital_status_id } className="da-mb-16"
                  { ...getErrorProps(errors['marital_status_id']) }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ martialstatuses }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="religion_id" label={ fieldLabel("religion_id", trans(`${langKey}.selectReligion`)) } rules={ rules.religion_id } className="da-mb-16"
                  { ...getErrorProps(errors['religion']) }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ religions }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item
                  name="nationality_id" label={ fieldLabel("nationality_id", trans(`${langKey}.selectNationality`)) } rules={ rules.nationality_id } className="da-mb-16"
                  { ...getErrorProps(errors['nationality_id']) }
                >
                  <SelectWithSearch
                    onChange={ onChangeNationality }
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ nationalities }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="blood_group_id" label={ fieldLabel("blood_group_id", trans(`${langKey}.selectBloodGroup`)) } rules={ rules.blood_group } className="da-mb-16"
                  { ...getErrorProps(errors['blood_group_id']) }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ bloodgroups }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="mobile_no" label={ fieldLabel("mobile_no", trans(`${langKey}.mobile`)) } className="da-mb-16"
                  { ...getErrorProps(errors['mobile_no']) } size="small"
                >
                  <InputText placeholder={ trans(`${langKey}.mobile`) } />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="landline_no" rules={ rules.landline_no } label={ fieldLabel("landline_no", trans(`${langKey}.landline`)) } className="da-mb-16"
                  { ...getErrorProps(errors['landline_no']) } size="small"
                >
                  <InputText placeholder={ trans(`${langKey}.landline`) } />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="email" label={ fieldLabel("email", trans(`${langKey}.email`)) } className="da-mb-16"
                  { ...getErrorProps(errors['email']) } size="small"
                >
                  <InputText placeholder={ trans(`${langKey}.email`) } />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item
                  name="cnic_no" rules={ selectedNationality === 166 ? rules.cnic_no : [] } label={ fieldLabel("cnic_no", trans(`${langKey}.cnic`)) } className="da-mb-16"
                  { ...getErrorProps(errors['cnic_no']) } size="small"
                >
                  <InputText placeholder={ trans(`${langKey}.cnic`) } onChange={ onChangeCnic } />
                </Form.Item>
              </Col>



              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="cnic_expiry_date" rules={ rules.cnic_expiry_date } label={ fieldLabel("cnic_expiry_date", trans(`${langKey}.cnicEpiry`)) } className="da-mb-16"
                  { ...getErrorProps(errors['cnic_expiry_date']) } size="small"
                >
                  <InputDate format="DD-MMM-YYYY" />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="passport_no" rules={ selectedNationality !== 166 ? rules.passport_no : [] } label={ fieldLabel("passport_no", trans(`${langKey}.passport`)) } className="da-mb-16"
                  { ...getErrorProps(errors['passport_no']) } size="small"
                >
                  <InputText placeholder={ trans(`${langKey}.passport`) } />
                </Form.Item>
              </Col>



              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="passport_expiry_date" rules={ rules.passport_expiry_date } label={ fieldLabel("passport_expiry_date", trans(`${langKey}.passportEpiry`)) } className="da-mb-16"
                  { ...getErrorProps(errors['passport_expiry_date']) } size="small"
                >
                  <InputDate format="DD-MMM-YYYY" />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="driving_license_no" rules={ rules.driving_license_no } label={ fieldLabel("driving_license_no", trans(`${langKey}.driving`)) } className="da-mb-16"
                  { ...getErrorProps(errors['driving_license_no']) } size="small"
                >
                  <InputText placeholder={ trans(`${langKey}.driving`) } />
                </Form.Item>
              </Col>


              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item
                  name="driving_license_expiry_date"
                  rules={ rules.driving_license_expiry_date } label={ fieldLabel("driving_license_expiry_date", trans(`${langKey}.drivingEpiry`)) } className="da-mb-16"
                  { ...getErrorProps(errors['driving_license_expiry_date']) } size="small"
                >
                  <InputDate format="DD-MMM-YYYY" />
                </Form.Item>
              </Col>
              <Divider className="create-employee-attachments-divider">
                Attachments
              </Divider>
              <Col span={ 24 }>
                <div className="create-employee-attachments-card">
                  <div className="create-employee-attachment-photo">
                    <Form.Item name="profile_pic" noStyle>
                      <Upload accept=".jpg,.png,.jpeg"
                        listType="picture-card"
                        fileList={ profilePicFileList }
                        onChange={ onChangeProfilePic }
                        onPreview={ onPreview }
                        multiple={ false }
                        maxCount={ 1 }
                        beforeUpload={ () => false }
                      >
                        { profilePicFileList.length === 1 ? null : (
                          <span className="create-employee-attachment-photo__placeholder">
                            <UploadOutlined />
                            <span>Photo</span>
                          </span>
                        ) }
                      </Upload>
                    </Form.Item>
                    <div className="create-employee-attachment-photo__meta">
                      <span>
                        { profilePicFileList.length > 0
                          ? getAttachmentFileName(profilePicFileList)
                          : trans(`${langKey}.uploadPhoto`) }
                      </span>
                      <strong>{ profilePicFileList.length > 0 ? "Done" : "Optional" }</strong>
                    </div>
                  </div>

                  <div className="create-employee-attachment-documents">
                    { renderDocumentAttachment({
                      name: "cnic_attachment",
                      label: trans(`${langKey}.cnicAttach`),
                      fileList: cnicFileList,
                      setFileList: setcnicFileList
                    }) }
                    { renderDocumentAttachment({
                      name: "passport_attachment",
                      label: trans(`${langKey}.passportAttach`),
                      fileList: passportFileList,
                      setFileList: setpassportFileList
                    }) }
                    { renderDocumentAttachment({
                      name: "driving_license_attachment",
                      label: trans(`${langKey}.drivingAttach`),
                      fileList: drivingLicenseFileList,
                      setFileList: setdrivingLicenseFileList
                    }) }
                  </div>
                </div>
              </Col>

            </Row>
          </div>

          <div className="employee-button">
            <Form.Item style={ { float: 'right' } }><Button className="employee-next-button" style={ { fontWeight: 600, } }
              type="primary" htmlType="submit" >
              Next
            </Button>
            </Form.Item>
            <Button className="employee-back-button" style={ { fontWeight: 600 } }
              type="primary" onClick={ () => setCurrent(currentStep - 1) } disabled="null">
              Back
            </Button>
          </div>
        </Form>


        <Modal open={ previewOpen } title={ previewTitle } footer={ null } onCancel={ handleCancel }>
          <img
            alt="example"
            style={ {
              width: '100%',
            } }
            src={ previewImage }
          />
        </Modal>
      </>
    )
  }


  //------------------step 2 form---------------------------
  // Create component modal
  //-----new grade------
  const onCreateGrade = () => {
    setChildComponent(<CreateGrade onCompleted={ onGradeCreated } />);
  };
  const onGradeCreated = (data) => {
    if (data.length) {
      employmentForm.setFieldValue('grade_id', data[0].id)
      setGrades(createSelectList(data))
    }
    setChildComponent(null);
  };

  const onChangeGrade = (id) => {

  }
  //-------onCreateLocation
  const onCreateLocation = () => {
    setChildComponent(<CreateLocation onCompleted={ onLocationCreated } />);
  };
  const onLocationCreated = (data) => {
    if (data.length) {
      employmentForm.setFieldValue('location_id', data[0].id)
      setLocations(createSelectList(data))
      onChangeLocation(data[0].id)
      employmentForm.setFieldValue("branch_id", null)
    }
    setChildComponent(null);
  };

  //--------new department------
  const onCreateDepartment = () => {
    setChildComponent(<CreateDepartment onCompleted={ onDepartmentCreated } />);
  };
  const onDepartmentCreated = (data) => {
    if (data.length) {
      employmentForm.setFieldValue('department_id', data[0].id)
      setDepartments(createSelectList(data))
    }
    setChildComponent(null);
  };
  //--------new branch------
  const onCreateBranch = () => {
    setChildComponent(<CreateBranch onCompleted={ onBranchCreated } />);
  };
  const onBranchCreated = (data) => {
    if (data.length) {
      employmentForm.setFieldValue('branch_id', data[0].id)
      setBranches(createSelectList(data))
    }
    setChildComponent(null);
  };
  //--------new Designation------
  const onCreateDesignation = () => {
    setChildComponent(<CreateDesignation onCompleted={ onDesignationCreated } />);
  };
  const onDesignationCreated = (data) => {
    if (data.length) {
      employmentForm.setFieldValue('designation_id', data[0].id)
      setDesignations(createSelectList(data))
    }
    setChildComponent(null);
  };
  //--------new job title------
  const onCreateJobTitle = () => {
    setChildComponent(<CreateJobTitle onCompleted={ onJobTitlesCreated } />);
  };
  const onJobTitlesCreated = (data) => {
    if (data.length) {
      employmentForm.setFieldValue('jobtitle_id', data[0].id)
      setJobTitles(createSelectList(data))
    }
    setChildComponent(null);
  };
  //==========new payroll creation=====
  const onPayrollCreated = (data) => {
    if (data.length) {
      salaryForm.setFieldValue('payroll_id', data[0].id)
      setPayrolls(createSelectList(data))
    }
    setChildComponent(null);
  };

  const onChangeCountry = (id) => {
    makeRequestStateless(getStatesByCountryReq, id, onGetStates, false)
  }

  const onGetStates = (data, response) => {
    setStates(createSelectList(data.all_states))
  }

  const onChangeState = (id) => {
    makeRequestStateless(getCitiesByStateReq, id, onGetCities, false)
  }

  const onGetCities = (data, response) => {
    setCities(createSelectList(data.cities))

  }

  const onSubmitAddress = (data) => {
    setAddressInfo(data)
    if (data) {
      setCurrent(currentStep + 1)
    }
  }
  const onSubmitContact = (data) => {
    setContactInfo(data)
    if (data) {
      setCurrent(currentStep + 1)
    }
  }
  const onSubmitEducation = (data) => {
    setEducationInfo(data)
    if (data) {
      setCurrent(currentStep + 1)
    }
  }
  const onChangeIsDegree = (e) => {
    setIsDegreeCompleted(e.target.checked)
  }

  const skipInfo = (e, step) => {
    const value = e.target.checked;

    if (step === 'address') {
      setHasAddress(value);
    }
    if (step === 'contact') {
      setHasContact(value);
    }
    if (step === 'education') {
      setHasEducation(value);
    }
    if (step === 'relative') {
      setHasRelative(value);
    }
    if (step === 'salary') {
      setSkipSalary(value);
      setCurrent(currentStep + 1)
    }

    if (!value) {
      return
    }

  }
  //--- Address form start-----------
  const employeeAddressForm = () => {
    return (
      <>
        <div className="employee-data"><h5 className="employee-data-style" style={ { fontWeight: 600 } }>Address Information</h5></div>
        <label className="m-4">Skip This Step ? <InputCheck onChange={ (e) => skipInfo(e, 'address') } checked={ hasAddress } /></label>
        <Form
          layout="vertical"
          name={ 'addressForm' }
          onFinish={ onSubmitAddress }
          initialValues={ addressInfo ? addressInfo : {} }
          form={ addressForm }
          scrollToFirstError>
          <div style={ { paddingTop: 25 } }>
            <Row gutter={ 30 }>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="address_type" label={ fieldLabel("address_type", trans(`${langKey}.select.addresstype`)) } rules={ hasAddress ? rules.address_type : [] } className="da-mb-16"
                  { ...getErrorProps(errors['address_type']) }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ [
                      {
                        value: 'Permanent',
                        label: 'Permanent',
                      },
                      {
                        value: 'Present',
                        label: 'Present',
                      },
                    ] }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="complete_address" rules={ hasAddress ? rules.complete_address : [] } label={ fieldLabel("complete_address", trans(`${langKey}.completeAddress`)) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['name']) } size="small"
                >
                  <InputText placeholder={ trans(`${langKey}.completeAddress`) } />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="country_id" label={ fieldLabel("country_id", trans(`${langKey}.select.country`)) } rules={ rules.country_id } className="da-mb-16"
                  { ...getErrorProps(errors['country_id']) }
                >
                  <SelectWithSearch
                    onChange={ onChangeCountry }
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ countries }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="state_id" label={ fieldLabel("state_id", trans(`${langKey}.select.state`)) } rules={ rules.state_id } className="da-mb-16"
                  { ...getErrorProps(errors['state_id']) }
                  disabled={ true }
                >
                  <SelectWithSearch
                    onChange={ onChangeState }
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ states }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="city_id" label={ fieldLabel("city_id", trans(`${langKey}.select.city`)) } rules={ rules.city_id } className="da-mb-16"
                  { ...getErrorProps(errors['city_id']) }
                  disabled={ true }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ cities }
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="employee-button" >
            <Form.Item style={ { float: 'right' } }>
              <Button className="employee-next-button" style={ { fontWeight: 600 } } type="primary" htmlType="submit" >
                Next
              </Button>
            </Form.Item>
            <Button className="employee-backs-button" style={ { fontWeight: 600 } } type="primary" onClick={ () => setCurrent(currentStep - 1) }>
              <span style={ { color: "#4079FC" } }>Back</span>
            </Button>
          </div>
        </Form>
      </>
    )
  }
  const employeeContactForm = () => {
    return (
      <>
        <div className="employee-data"><h5 className="employee-data-style" style={ { fontWeight: 600 } }>Contact Information</h5></div>
        <label className="m-4">Skip This Step ? <InputCheck onChange={ (e) => skipInfo(e, 'contact') } checked={ hasContact } /></label>
        <div style={ { paddingTop: 25 } }>
          <Form layout="vertical" initialValues={ contactInfo ? contactInfo : {} } name={ 'contactForm' } onFinish={ onSubmitContact } scrollToFirstError>
            <Row gutter={ 30 }>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="contact_type" label={ fieldLabel("contact_type", trans(`${langKey}.select.contact_type`)) } rules={ hasContact ? rules.contact_type : [] } className="da-mb-16"
                  { ...getErrorProps(errors['contact_type']) }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ [{
                      'value': "Primary",
                      "label": "Primary"
                    },
                    {
                      "value": "Secondary",
                      "label": "Secondary"
                    }

                    ] }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="name" rules={ hasContact ? rules.name : [] } label={ fieldLabel("name", trans(`${langKey}.name`)) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['name']) } size="small"

                >
                  <InputText placeholder={ trans(`${langKey}.name`) } />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="relationship" label={ fieldLabel("relationship", trans(`${langKey}.select.relationship`)) } rules={ hasContact ? rules.relationship : [] } className="da-mb-16"
                  { ...getErrorProps(errors['relationship']) }
                >
                  <SelectWithSearch

                    placeholder={ SELECT_PLACEHOLDER }
                    options={ relationships }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="landline_no" rules={ rules.landline_no } label={ fieldLabel("landline_no", trans(`${langKey}.landline_no`)) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['landline_no']) } size="small"

                >
                  <InputText placeholder={ trans(`${langKey}.landline_no`) } />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="mobile_no" rules={ hasContact ? rules.mobile_no : [] } label={ fieldLabel("mobile_no", trans(`${langKey}.mobile_no`)) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['mobile_no']) } size="small"

                >
                  <InputText placeholder={ trans(`${langKey}.mobile_no`) } />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="email" label={ fieldLabel("email", trans(`${langKey}.email`)) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['email']) } size="small"

                >
                  <InputText placeholder={ trans(`${langKey}.email`) } type="email" />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="address" label={ fieldLabel("address", trans(`${langKey}.address`)) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['address']) } size="small"

                >
                  <InputText placeholder={ trans(`${langKey}.address`) } />
                </Form.Item>
              </Col>
            </Row>

            <div className="employee-button" >
              <Form.Item style={ { float: 'right' } }>
                <Button className="employee-next-button" style={ { fontWeight: 600 } } type="primary" htmlType="submit" >
                  Next
                </Button>
              </Form.Item>
              <Button className="employee-backs-button" style={ { fontWeight: 600 } } type="primary" onClick={ () => setCurrent(currentStep - 1) }>
                <span style={ { color: "#4079FC" } }>Back</span>
              </Button>
            </div>
          </Form>
        </div>
      </>
    )
  }
  const employeeEducationForm = () => {
    return (
      <>
        <div className="employee-data"><h5 className="employee-data-style" style={ { fontWeight: 600 } }>Education Information</h5></div>
        <label className="m-4">Skip this step ? <InputCheck onChange={ (e) => skipInfo(e, 'education') } checked={ hasEducation } /></label>
        <div style={ { paddingTop: 25 } }>
          <Form layout="vertical" initialValues={ educationInfo ? educationInfo : {} }
            name={ 'educationForm' } onFinish={ onSubmitEducation } scrollToFirstError>
            <Row gutter={ 30 }>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="institute_name" rules={ hasEducation ? rules.institute_name : [] } label={ fieldLabel("institute_name", trans(`${langKey}.institute_name`)) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['institute_name']) } size="small"
                >
                  <InputText placeholder={ trans(`${langKey}.institute_name`) } />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="degree" rules={ hasEducation ? rules.degree : [] } label={ fieldLabel("degree", trans(`${langKey}.degree`)) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['degree']) } size="small"
                >
                  <InputText placeholder={ trans(`${langKey}.degree`) } />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item valuePropName="checked" name="is_degree_completed" label={ fieldLabel("is_degree_completed", trans(`${langKey}.is_degree_completed`)) } className="da-mb-16">
                  <Checkbox onChange={ onChangeIsDegree }></Checkbox>
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="from_date" label={ fieldLabel("from_date", trans(`${langKey}.from_date`)) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['from_date']) } size="small"

                >
                  <InputDate format='YYYY-MM-DD' />
                </Form.Item>
              </Col>
              { isDegreeCompleted && <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="to_date" rules={ isDegreeCompleted ? rules.to_date : [] } label={ fieldLabel("to_date", trans(`${langKey}.to_date`)) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['to_date']) } size="small"

                >
                  <InputDate format='YYYY-MM-DD' />
                </Form.Item>
              </Col> }


              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="country" rules={ rules.country } label={ fieldLabel("country", trans(`${langKey}.country`)) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['country']) } size="small"
                >
                  <InputText placeholder={ trans(`${langKey}.country`) } />
                </Form.Item>
              </Col>

              {/* <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item label={ fieldLabel("degree_attachment", trans(`${langKey}.attachment`)) } name="degree_attachment" >
                <UploadFile
                  accept=".jpg,.png,.jpeg" listType="picture-card"
                  fileList={ fileList }
                  onChange={ onChange }
                  onPreview={ onPreview }
                  multiple={ false }
                  beforeUpload={ (file) => {
                    return false;
                  } }
                >
                  { fileList.length === 1 ? null : <UploadButton /> }
                </UploadFile>
              </Form.Item>
            </Col> */}

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="city" rules={ rules.city } label={ fieldLabel("city", trans(`${langKey}.city`)) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['city']) } size="small"

                >
                  <InputText placeholder={ trans(`${langKey}.city`) } />
                </Form.Item>
              </Col>

            </Row>

            <div className="employee-button">
              <Form.Item style={ { float: 'right' } }>
                <Button className="employee-next-button" style={ { fontWeight: 600 } } type="primary" htmlType="submit" disabled={ employeeInfo ? false : true } >
                  Next
                </Button>
              </Form.Item>
              <Button className="employee-backs-button" style={ { fontWeight: 600 } } type="primary" onClick={ () => setCurrent(currentStep - 1) }>
                <span style={ { color: "#4079FC" } }>Back</span>
              </Button>
            </div>
          </Form>
        </div>
      </>
    )
  }

  //---employment form start-----------
  const employeeEmploymentForm = () => {
    return (<>
      { childComponent }
      <div className="employee-data"><h5 className="employee-data-style" style={ { fontWeight: 600 } }>Employment Details</h5></div>

      <Form
        // { ...formLayout }
        layout="vertical"
        requiredMark={ renderRequiredMark }
        name={ createEmployment }
        id={ createEmployment }
        onFinish={ onSubmitEmployment }
        initialValues={ employmentInfo }
        form={ employmentForm }
        onValuesChange={ persistEmployeeDraft }
        scrollToFirstError
      >
        <div style={ { paddingTop: 25 } }>
          <Row gutter={ 20 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="prev_code" rules={ rules.user_defined_Code } label={ fieldLabel("prev_code", trans(`${langKey}.userDefinedCode`)) } className="da-mb-16"
                { ...getErrorProps(errors['user_defined_Code']) } size="small"
              >
                <InputText
                  placeholder={ trans(`${langKey}.userDefinedCode`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="joining_date" rules={ rules.joining_date } label={ fieldLabel("joining_date", "Date of Joining") } className="da-mb-16"
                { ...getErrorProps(errors['joining_date']) } size="small"
              >
                <InputDate format="DD-MMM-YYYY" />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <div className="klok-field-action">
                <Form.Item name="grade_id" label={ fieldLabel("grade_id", trans(`${langKey}.selectgrades`)) } rules={ rules.grade_id } className="da-mb-16"
                  { ...getErrorProps(errors['grade_id']) }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ grades }
                    onChange={ onChangeGrade }
                  />
                </Form.Item>
                <AddNewButton onClick={ onCreateGrade } />
              </div>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <div className="klok-field-action">
                <Form.Item name="location_id" label={ fieldLabel("location_id", trans(`${langKey}.selectlocation`)) } rules={ rules.location_id } className="da-mb-16"
                  { ...getErrorProps(errors['location_id']) }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ locations }
                    onChange={ onChangeLocation }
                  />
                </Form.Item>
                <AddNewButton onClick={ onCreateLocation } />
              </div>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <div className="klok-field-action">
                <Form.Item name="department_id" label={ fieldLabel("department_id", trans(`${langKey}.selectdepartment`)) } rules={ rules.department_id }
                  { ...getErrorProps(errors['department_id']) }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ departments }
                  />
                </Form.Item>
                <AddNewButton onClick={ onCreateDepartment } />
              </div>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <div className="klok-field-action">
                <Form.Item name="branch_id" label={ fieldLabel("branch_id", trans(`${langKey}.selectbranch`)) } rules={ rules.branch_id }
                  { ...getErrorProps(errors['branch_id']) }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ branches }
                  />
                </Form.Item>
                <AddNewButton onClick={ onCreateBranch } />
              </div>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <div className="klok-field-action">
                <Form.Item name="designation_id" label={ fieldLabel("designation_id", trans(`${langKey}.selectdesignation`)) } rules={ rules.designation_id }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ designations }
                  />
                </Form.Item>
                <AddNewButton onClick={ onCreateDesignation } />
              </div>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_on_probation" label={ fieldLabel("is_on_probation", trans(`${langKey}.probation`)) } initialValue={ false } >
                <SelectWithSearch options={ [
                  {
                    label: "Yes",
                    value: true
                  },
                  {
                    label: "No",
                    value: false
                  }
                ] }
                  onChange={ (e) => {
                    setIsProbation(e)
                  } } defaultValue={ false } />
              </Form.Item>

              { isProbation ?
                <Form.Item style={ { marginTop: 35 } } name="probation_period_month" rules={ isProbation ? rules.probation_end_date : [] } label={ fieldLabel("probation_period_month", trans(`${langKey}.probationEndDate`)) } className="da-mb-16"
                  { ...getErrorProps(errors['probation_end_date']) } size="small"
                >
                  <InputText placeholder={ trans(`${langKey}.probationEndDate`) } type="number" onWheel={ (e) => e.target.blur() } disabled={ isProbation ? false : true } />
                </Form.Item> : ''
              }
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <div className="klok-field-action">
                <Form.Item name="jobtitle_id" label={ fieldLabel("jobtitle_id", trans(`${langKey}.selectjobtitle`)) } rules={ rules.jobtitle_id }
                  { ...getErrorProps(errors['jobtitle_id']) }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ jobTitles }
                  />
                </Form.Item>
                <AddNewButton onClick={ onCreateJobTitle } />
              </div>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="official_email" rules={ rules.official_email } label={ fieldLabel("official_email", trans(`${langKey}.officialEmail`)) }
              >
                <InputText
                  placeholder={ trans(`${langKey}.officialEmail`) } type="email" />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item style={ { paddingTop: 0 } } name="employee_type_id" label={ fieldLabel("employee_type_id", trans(`${langKey}.selectemployeetype`)) } rules={ rules.employee_type_id }
                { ...getErrorProps(errors['employee_type_id']) }
              >
                <SelectWithSearch
                  placeholder={ SELECT_PLACEHOLDER }
                  options={ employeeTypes }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item
                name="contracttype_id" label={ fieldLabel("contracttype_id", trans(`${langKey}.selectemploymenttype`)) } rules={ rules.contracttype_id } className="da-mb-16"
                { ...getErrorProps(errors['contracttype_id']) }
              >
                <SelectWithSearch
                  onChange={ onChangeEmploymentType }
                  placeholder={ SELECT_PLACEHOLDER }
                  options={ employmentTypes }
                />
              </Form.Item>
            </Col>
            { isEmploymentType === 1 ?
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="contract_expiry_date" rules={ rules.contract_expiry_date } label={ fieldLabel("contract_expiry_date", trans(`${langKey}.contract_expiry_date`)) } className="da-mb-16"
                  { ...getErrorProps(errors['contract_expiry_date']) }
                >
                  <InputDate />
                </Form.Item>
              </Col>
              : '' }
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item valuePropName="checked" name="exempt_attendance" label={ fieldLabel("exempt_attendance", "Is Attendance Exempt") } className="da-mb-16">
                <Checkbox></Checkbox>
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item valuePropName="checked" name="is_retail" label={ fieldLabel("is_retail", trans(`${langKey}.isretailemployee`)) } className="da-mb-16">
                <div style={ { display: "flex", marginLeft: -0, color: '#687980' } }>

                  <Form.Item valuePropName="checked" name="is_final_authority">
                    <Checkbox onChange={ onChangeIsFinalAuthority }>Is Final Authority</Checkbox>
                  </Form.Item>

                  <Form.Item valuePropName="checked" name="is_hod">
                    <Checkbox checked={ isFinalAuthority } disabled={ isFinalAuthority }>Is HOD</Checkbox>
                  </Form.Item>

                  <Form.Item valuePropName="checked" name="is_manager">
                    <Checkbox checked={ isFinalAuthority } disabled={ isFinalAuthority }>Is Line Manager</Checkbox>
                  </Form.Item>
                </div>
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item
                name="linemanager_id"
                label={ fieldLabel("linemanager_id", trans(`${langKey}.selectlinemanager`)) } rules={ !isFinalAuthority ? rules.linemanager_id : [] } className="da-mb-16"
                { ...getErrorProps(errors['linemanager_id']) }
                style={ { display: isFinalAuthority ? 'none' : 'block' } }
              >
                <SelectWithSearch
                  placeholder={ SELECT_PLACEHOLDER }
                  options={ lineManagers }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item
                name="final_authority_id"
                label={ fieldLabel("final_authority_id", trans(`${langKey}.selectfinalauthority`)) } rules={ !isFinalAuthority ? rules.finalauthority : [] } className="da-mb-16"
                { ...getErrorProps(errors['finalauthority']) }
                style={ { display: isFinalAuthority ? 'none' : 'block', marginTop: 0 } }
              >
                <SelectWithSearch
                  placeholder={ SELECT_PLACEHOLDER }
                  options={ finalAuthorities }
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <div className="employee-button">
          <Form.Item style={ { float: 'right' } }>
            <Button className="employee-next-button" style={ { fontWeight: 600 } } type="primary" htmlType="submit" disabled={ employeeInfo ? false : true } >
              Next
            </Button>
          </Form.Item>
          <Button className="employee-backs-button" style={ { fontWeight: 600 } } type="primary" onClick={ () => setCurrent(currentStep - 1) }>
            <span style={ { color: "#4079FC" } }>Back</span>
          </Button>
        </div>
      </Form>
    </>)
  }
  //-----------------
  //------------------step 3 form---------------------------
  const payrollSalaryForm = () => {
    return (
      <>
        <div className="employee-data"><h5 className="employee-data-style" style={ { fontWeight: 600 } }>Payroll & Salary</h5></div>
        <label className="m-4">Skip This Step ? <InputCheck onChange={ (e) => skipInfo(e, 'salary') } checked={ skipSalary } /></label>
        { childComponent }
        <Form
          // { ...formLayout }
          layout="vertical"
          requiredMark={ renderRequiredMark }
          name={ 'createPayroll' }
          id="createPayroll"
          onFinish={ onSubmitSalary }
          initialValues={ salaryInfo ? salaryInfo : {} }
          form={ salaryForm }
          onValuesChange={ persistEmployeeDraft }
          scrollToFirstError
        >
          <div style={ { paddingTop: 25 } }>
            <Row gutter={ 20 }>
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <div className="klok-field-action">
                  <Form.Item name="payroll_id" rules={ !skipSalary ? rules.payroll : [] } label={ fieldLabel("payroll_id", trans(`${langKey}.payroll`)) } className="da-mb-16"
                    { ...getErrorProps(errors['payroll']) } size="small"
                  >
                    <SelectWithSearch options={ payrolls } placeholder={ SELECT_PLACEHOLDER } />
                  </Form.Item>
                  <AddNewButton onClick={ () => setChildComponent(<CreatePayroll onCompleted={ onPayrollCreated } />) } />
                </div>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="type" label={ fieldLabel("type", trans(`${langKey}.payrollType`)) } rules={ !skipSalary ? rules.payrollType : [] } className="da-mb-16"
                  { ...getErrorProps(errors['payrollType']) }
                >
                  <SelectWithSearch
                    options={ salaryTypes }
                    placeholder={ SELECT_PLACEHOLDER }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="payment_method_id" rules={ !skipSalary ? rules.payrollMethod : [] } label={ fieldLabel("payment_method_id", trans(`${langKey}.payrollMethod`)) } className="da-mb-16"
                  { ...getErrorProps(errors['payrollMethod']) } size="small"
                >
                  <SelectWithSearch options={ paymentmethods } placeholder={ SELECT_PLACEHOLDER } />
                </Form.Item>
              </Col>
              { ispaymentMethod === 1 && <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                {/* <AddNewButton type="primary" onClick={ () => setChildComponent(<CreateBank onCompleted={ onCompleted } />) } /> */ }

                <Form.Item name="bank_id" label={ fieldLabel("bank_id", trans(`${langKey}.bank_id`)) } rules={ rules.bank_id } className="da-mb-16"
                  { ...getErrorProps(errors['bank_id']) }

                >
                  <SelectWithSearch options={ [] } placeholder={ trans(`${langKey}.bank_id`) } />

                </Form.Item>
              </Col> }
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="gross_salary" rules={ !skipSalary ? rules.grossSalary : [] } label={ fieldLabel("gross_salary", trans(`${langKey}.grossSalary`)) } className="da-mb-16"
                  { ...getErrorProps(errors['grossSalary']) } size="small"

                >
                  <InputText type="number" onWheel={ (e) => e.target.blur() } placeholder="0.00" />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="policy_id" rules={ [] } label={ fieldLabel("policy_id", trans(`${langKey}.policy`)) } className="da-mb-16"
                  { ...getErrorProps(errors['policy']) } size="small"
                >
                  <SelectWithSearch options={ policies } placeholder={ SELECT_PLACEHOLDER } />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="employee-button" >
            <Form.Item style={ { float: 'right' } }>
              <Button className="employee-next-button" style={ { fontWeight: 600 } } type="primary" htmlType="submit" >
                Next
              </Button>
            </Form.Item>
            <Button className="employee-backs-button" style={ { fontWeight: 600 } } type="primary" onClick={ () => setCurrent(currentStep - 1) }>
              <span style={ { color: "#4079FC" } }>Back</span>
            </Button>
          </div>
        </Form>
      </>
    )
  }

  //-----------------
  //------------------step 4 form---------------------------
  const userForm = () => {
    return (
      <>
        <div className="employee-data"><h5 className="employee-data-style" style={ { fontWeight: 600 } }>Account Setting</h5></div>

        <Form
          // { ...formLayout }
          layout="vertical"
          requiredMark={ renderRequiredMark }
          name={ createUser }
          id={ createUser }
          onFinish={ onSubmitUser }
          initialValues={ userInfo }
          form={ userFormInstance }
          onValuesChange={ persistEmployeeDraft }
          autoComplete="off"
          scrollToFirstError
        >
          <div style={ { paddingTop: 25 } }>
            <Row gutter={ 20 }>
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="email" rules={ rules.user_name } label={ fieldLabel("email", trans(`${langKey}.username`)) } className="da-mb-16"
                  { ...getErrorProps(errors['username']) } size="small"
                >
                  <InputText placeholder="Login username" />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="role_id" label={ fieldLabel("role_id", trans(`${langKey}.selectrole`)) } rules={ rules.role_id } className="da-mb-16"
                  { ...getErrorProps(errors['role_id']) }
                >
                  <SelectWithSearch
                    placeholder={ SELECT_PLACEHOLDER }
                    options={ roles }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="password" rules={ rules.password } label={ fieldLabel("password", trans(`${langKey}.password`)) } className="da-mb-16"
                  { ...getErrorProps(errors['password']) } size="small"
                >
                  <Input.Password placeholder="Enter your password" type="password" />
                </Form.Item>
              </Col>
            </Row>
          </div >

          <div className="employee-button" >
            <Form.Item style={ { float: 'right' } }>
              <Button className="employee-next-button" style={ { fontWeight: 600 } } type="primary" htmlType="submit">
                Next
              </Button>
            </Form.Item>
            <Button className="employee-backs-button" style={ { fontWeight: 600 } } type="primary" onClick={ () => setCurrent(currentStep - 1) }>
              <span style={ { color: "#4079FC" } }>Back</span>
            </Button>
          </div>
        </Form >
      </>
    )
  }
  const employeeOthersInfo = () => {
    return (
      <>
        <Form
          layout="vertical"
          requiredMark={ renderRequiredMark }
          name={ 'othersForm' }
          id="othersForm"
          onFinish={ onSaveAllData }
          form={ othersForm }
          onValuesChange={ persistEmployeeDraft }
          scrollToFirstError>
          <div className="employee-data"><h5 className="employee-data-style" style={ { fontWeight: 600 } }>Address Information <InputCheck onChange={ (e) => skipInfo(e, 'address') } checked={ hasAddress } /></h5> </div>

          { hasAddress && <Form
            layout="vertical"
            requiredMark={ renderRequiredMark }
            name={ 'addressForm' }
            onFinish={ onSubmitAddress }
            initialValues={ addressInfo ? addressInfo : {} }
            form={ addressForm }
            onValuesChange={ persistEmployeeDraft }
            scrollToFirstError>
            <div style={ { paddingTop: 25 } }>

              <Row gutter={ 30 }>

                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="address_type" label={ fieldLabel("address_type", trans(`${langKey}.select.addresstype`)) } rules={ hasAddress ? rules.address_type : [] } className="da-mb-16"
                    { ...getErrorProps(errors['address_type']) }
                  >
                    <SelectWithSearch
                      placeholder={ SELECT_PLACEHOLDER }
                      options={ [
                        {
                          value: 'Permanent',
                          label: 'Permanent',
                        },
                        {
                          value: 'Present',
                          label: 'Present',
                        },
                      ] }
                    />
                  </Form.Item>
                </Col>

                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="complete_address" rules={ hasAddress ? rules.complete_address : [] } label={ fieldLabel("complete_address", trans(`${langKey}.completeAddress`)) }
                    className="da-mb-16"
                    { ...getErrorProps(errors['name']) } size="small"
                  >
                    <InputText placeholder={ trans(`${langKey}.completeAddress`) } />
                  </Form.Item>
                </Col>

                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="country_id" label={ fieldLabel("country_id", trans(`${langKey}.select.country`)) } rules={ rules.country_id } className="da-mb-16"
                    { ...getErrorProps(errors['country_id']) }
                  >
                    <SelectWithSearch
                      onChange={ onChangeCountry }
                      placeholder={ SELECT_PLACEHOLDER }
                      options={ countries }
                    />
                  </Form.Item>
                </Col>

                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="state_id" label={ fieldLabel("state_id", trans(`${langKey}.select.state`)) } rules={ rules.state_id } className="da-mb-16"
                    { ...getErrorProps(errors['state_id']) }
                    disabled={ true }
                  >
                    <SelectWithSearch
                      onChange={ onChangeState }
                      placeholder={ SELECT_PLACEHOLDER }
                      options={ states }
                    />
                  </Form.Item>
                </Col>

                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="city_id" label={ fieldLabel("city_id", trans(`${langKey}.select.city`)) } rules={ rules.city_id } className="da-mb-16"
                    { ...getErrorProps(errors['city_id']) }
                    disabled={ true }
                  >
                    <SelectWithSearch
                      placeholder={ SELECT_PLACEHOLDER }
                      options={ cities }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            {/* <div className="employee-button" >
             <Form.Item style={ { float: 'right' } }>
               <Button className="employee-next-button" style={ { fontWeight: 600 } } type="primary" htmlType="submit" >
                 Next
               </Button>
             </Form.Item>
             <Button className="employee-backs-button" style={ { fontWeight: 600 } } type="primary" onClick={ () => setCurrent(currentStep - 1) }>
               <span style={ { color: "#4079FC" } }>Back</span>
             </Button>
           </div> */}
          </Form> }

          <>
            <div className="employee-data"><h5 className="employee-data-style" style={ { fontWeight: 600 } }>Contact Information <InputCheck onChange={ (e) => skipInfo(e, 'contact') } checked={ hasContact } /></h5></div>

            { hasContact && <div style={ { paddingTop: 25 } }>
              <Form layout="vertical" requiredMark={ renderRequiredMark } initialValues={ contactInfo ? contactInfo : {} } name={ 'contactForm' } onFinish={ onSubmitContact } form={ contactForm } onValuesChange={ persistEmployeeDraft } scrollToFirstError>
                <Row gutter={ 30 }>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="contact_type" label={ fieldLabel("contact_type", trans(`${langKey}.select.contact_type`)) } rules={ hasContact ? rules.contact_type : [] } className="da-mb-16"
                      { ...getErrorProps(errors['contact_type']) }
                    >
                      <SelectWithSearch
                        placeholder={ SELECT_PLACEHOLDER }
                        options={ [{
                          'value': "Primary",
                          "label": "Primary"
                        },
                        {
                          "value": "Secondary",
                          "label": "Secondary"
                        }

                        ] }
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="name" rules={ hasContact ? rules.name : [] } label={ fieldLabel("name", trans(`${langKey}.name`)) }
                      className="da-mb-16"
                      { ...getErrorProps(errors['name']) } size="small"

                    >
                      <InputText placeholder={ trans(`${langKey}.name`) } />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="relationship" label={ fieldLabel("relationship", trans(`${langKey}.select.relationship`)) } rules={ hasContact ? rules.relationship : [] } className="da-mb-16"
                      { ...getErrorProps(errors['relationship']) }
                    >
                      <SelectWithSearch

                        placeholder={ SELECT_PLACEHOLDER }
                        options={ relationships }
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="landline_no" rules={ rules.landline_no } label={ fieldLabel("landline_no", trans(`${langKey}.landline_no`)) }
                      className="da-mb-16"
                      { ...getErrorProps(errors['landline_no']) } size="small"

                    >
                      <InputText placeholder={ trans(`${langKey}.landline_no`) } />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="mobile_no" rules={ hasContact ? rules.mobile_no : [] } label={ fieldLabel("mobile_no", trans(`${langKey}.mobile_no`)) }
                      className="da-mb-16"
                      { ...getErrorProps(errors['mobile_no']) } size="small"

                    >
                      <InputText placeholder={ trans(`${langKey}.mobile_no`) } />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="email" label={ fieldLabel("email", trans(`${langKey}.email`)) }
                      className="da-mb-16"
                      { ...getErrorProps(errors['email']) } size="small"

                    >
                      <InputText placeholder={ trans(`${langKey}.email`) } type="email" />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="address" label={ fieldLabel("address", trans(`${langKey}.address`)) }
                      className="da-mb-16"
                      { ...getErrorProps(errors['address']) } size="small"

                    >
                      <InputText placeholder={ trans(`${langKey}.address`) } />
                    </Form.Item>
                  </Col>
                </Row>

                {/* <div className="employee-button" >
            <Form.Item style={ { float: 'right' } }>
              <Button className="employee-next-button" style={ { fontWeight: 600 } } type="primary" htmlType="submit" >
                Next
              </Button>
            </Form.Item>
            <Button className="employee-backs-button" style={ { fontWeight: 600 } } type="primary" onClick={ () => setCurrent(currentStep - 1) }>
              <span style={ { color: "#4079FC" } }>Back</span>
            </Button>
          </div> */}
              </Form>
            </div> }

            <>
              <div className="employee-data"><h5 className="employee-data-style" style={ { fontWeight: 600 } }>Education Information <InputCheck onChange={ (e) => skipInfo(e, 'education') } checked={ hasEducation } /></h5></div>
              {
                hasEducation && <div style={ { paddingTop: 25 } }>
                  <Form layout="vertical" requiredMark={ renderRequiredMark } initialValues={ educationInfo ? educationInfo : {} }
                    name={ 'educationForm' } onFinish={ onSubmitEducation } form={ educationForm } onValuesChange={ persistEmployeeDraft } scrollToFirstError>
                    <Row gutter={ 30 }>

                      <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                        <Form.Item name="institute_name" rules={ hasEducation ? rules.institute_name : [] } label={ fieldLabel("institute_name", trans(`${langKey}.institute_name`)) }
                          className="da-mb-16"
                          { ...getErrorProps(errors['institute_name']) } size="small"
                        >
                          <InputText placeholder={ trans(`${langKey}.institute_name`) } />
                        </Form.Item>
                      </Col>

                      <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                        <Form.Item name="degree" rules={ hasEducation ? rules.degree : [] } label={ fieldLabel("degree", trans(`${langKey}.degree`)) }
                          className="da-mb-16"
                          { ...getErrorProps(errors['degree']) } size="small"
                        >
                          <InputText placeholder={ trans(`${langKey}.degree`) } />
                        </Form.Item>
                      </Col>

                      <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                        <Form.Item valuePropName="checked" name="is_degree_completed" label={ fieldLabel("is_degree_completed", trans(`${langKey}.is_degree_completed`)) } className="da-mb-16">
                          <Checkbox onChange={ onChangeIsDegree }></Checkbox>
                        </Form.Item>
                      </Col>

                      <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                        <Form.Item name="from_date" label={ fieldLabel("from_date", trans(`${langKey}.from_date`)) }
                          className="da-mb-16"
                          { ...getErrorProps(errors['from_date']) } size="small"

                        >
                          <InputDate format='YYYY-MM-DD' />
                        </Form.Item>
                      </Col>

                      <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                        <Form.Item name="to_date" label={ fieldLabel("to_date", trans(`${langKey}.to_date`)) }
                          className="da-mb-16"
                          { ...getErrorProps(errors['to_date']) } size="small"

                        >
                          <InputDate format='YYYY-MM-DD' />
                        </Form.Item>
                      </Col>

                      <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                        <Form.Item name="country" rules={ rules.country } label={ fieldLabel("country", trans(`${langKey}.country`)) }
                          className="da-mb-16"
                          { ...getErrorProps(errors['country']) } size="small"
                        >
                          <InputText placeholder={ trans(`${langKey}.country`) } />
                        </Form.Item>
                      </Col>

                      {/* <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item label={ fieldLabel("degree_attachment", trans(`${langKey}.attachment`)) } name="degree_attachment" >
                  <UploadFile
                    accept=".jpg,.png,.jpeg" listType="picture-card"
                    fileList={ fileList }
                    onChange={ onChange }
                    onPreview={ onPreview }
                    multiple={ false }
                    beforeUpload={ (file) => {
                      return false;
                    } }
                  >
                    { fileList.length === 1 ? null : <UploadButton /> }
                  </UploadFile>
                </Form.Item>
              </Col> */}

                      <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                        <Form.Item name="city" rules={ rules.city } label={ fieldLabel("city", trans(`${langKey}.city`)) }
                          className="da-mb-16"
                          { ...getErrorProps(errors['city']) } size="small"

                        >
                          <InputText placeholder={ trans(`${langKey}.city`) } />
                        </Form.Item>
                      </Col>

                    </Row>

                    {/* <div className="employee-button">
            <Form.Item style={ { float: 'right' } }>
              <Button className="employee-next-button" style={ { fontWeight: 600 } } type="primary" htmlType="submit" disabled={ employeeInfo ? false : true } >
                Next
              </Button>
            </Form.Item>
            <Button className="employee-backs-button" style={ { fontWeight: 600 } } type="primary" onClick={ () => setCurrent(currentStep - 1) }>
              <span style={ { color: "#4079FC" } }>Back</span>
            </Button>
          </div> */}
                  </Form>
                </div>
              }

            </>
            <div className="employee-data"><h5 className="employee-data-style" style={ { fontWeight: 600 } }>Relative Information<InputCheck onChange={ (e) => skipInfo(e, 'relative') } checked={ hasRelative } /></h5></div>
          </>

          { hasRelative &&


            <div style={ { paddingTop: 25 } }>
              <Form form={ relativesForm } name="relativesForm" requiredMark={ renderRequiredMark } onValuesChange={ persistEmployeeDraft } { ...formLayout }>

                <div className="formlist-container">
                  <h5 className="formlist-title">{ trans(`${langKey}.relatives`) }</h5>
                  <Form.List name="relatives" initialValue={ relativesInfo } >
                    { (fields, { add, remove }) => (
                      <>
                        <Button onClick={ () => {
                          add()

                        } } icon={ <PlusOutlined /> } type="primary" className="add-node-button">Add Item</Button>
                        <div className="table-container">
                          <table className="table">
                            {
                              fields.length !== 0 && <thead>
                                <tr>
                                  {/* <th style={ { paddingLeft: 20 } }>{ trans(`${langKey}.employee`) }<small className="text-danger"> *</small></th> */ }
                                  <th>{ trans(`${langKey}.relationship`) }<small className="text-danger"> *</small></th>
                                  <th>{ trans(`${langKey}.name`) }<small className="text-danger"> *</small></th>
                                  <th>{ trans(`${langKey}.phone_no`) }<small className="text-danger"> *</small></th>
                                  <th>{ trans(`${langKey}.email`) }</th>
                                  <th>{ trans(`${langKey}.d_o_b`) }</th>

                                  <th>{ trans(`${langKey}.cnic_no`) }</th>
                                  <th>{ trans(`${langKey}.address`) }</th>
                                  <th>{ trans(`${langKey}.is_dependant`) }</th>
                                  <th>{ trans(Commons.actions) }</th>
                                </tr>
                              </thead>
                            }
                            <tbody>
                              { fields.map(({ key, name, ...restField }) => (
                                <>
                                  <tr style={ { marginTop: '5px', marginBottom: '5px' } }>

                                    {/* <td style={ { minWidth: '200px', paddingLeft: 20 } }>
                                  <Form.Item
                                    { ...restField }
                                    name={ [name, 'employee_id'] }
                                    rules={ rules.employee_id }
                                  >
                                     <SelectResourceList type='employee' />
                                  </Form.Item>
                                </td> */}
                                    <td style={ { minWidth: '200px', paddingLeft: 20 } }>
                                      <Form.Item
                                        { ...restField }
                                        name={ [name, 'relationship'] }
                                        rules={ rules.relationship }
                                      >
                                        <SelectWithSearch
                                          options={ relationships }
                                          placeholder={ SELECT_PLACEHOLDER } />
                                      </Form.Item>
                                    </td>

                                    <td style={ { minWidth: '200px' } }>
                                      <Form.Item
                                        { ...restField }
                                        name={ [name, 'name'] }
                                        rules={ rules.name }
                                      >
                                        <InputText />
                                      </Form.Item>
                                    </td>
                                    <td style={ { minWidth: '200px' } }>
                                      <Form.Item
                                        { ...restField }
                                        name={ [name, 'phone_no'] }
                                        rules={ rules.rel_phone_no }
                                      >
                                        <InputText type="number" onWheel={ (e) => e.target.blur() } />
                                      </Form.Item>
                                    </td>
                                    <td style={ { minWidth: '200px' } }>
                                      <Form.Item
                                        { ...restField }
                                        name={ [name, 'email'] }
                                        rules={ rules.email }
                                      >
                                        <InputText />
                                      </Form.Item>
                                    </td>
                                    <td style={ { minWidth: '200px' } }>
                                      <Form.Item
                                        { ...restField }
                                        name={ [name, 'd_o_b'] }
                                        rules={ rules.d_o_b }
                                      >
                                        <InputDate />
                                      </Form.Item>
                                    </td>
                                    <td style={ { minWidth: '200px' } }>
                                      <Form.Item
                                        { ...restField }
                                        name={ [name, 'cnic_no'] }
                                        rules={ rules.cnic_no }
                                      >
                                        <InputText type="number" onWheel={ (e) => e.target.blur() } />
                                      </Form.Item>
                                    </td>
                                    <td style={ { minWidth: '200px' } }>
                                      <Form.Item
                                        { ...restField }
                                        name={ [name, 'address'] }
                                        rules={ rules.address }
                                      >
                                        <InputTextArea />
                                      </Form.Item>
                                    </td>

                                    <td style={ { minWidth: '200px' } }>
                                      <Form.Item
                                        { ...restField }
                                        name={ [name, 'is_dependant'] }
                                        rules={ rules.is_dependant }
                                        valuePropName="checked"
                                      >
                                        <InputCheck />
                                      </Form.Item>
                                    </td>
                                    <td>
                                      <DeleteOutlined className="formlist-remove" onClick={ () => {
                                        remove(name)
                                      } } />
                                    </td>
                                  </tr>
                                </>
                              )) }
                            </tbody>
                          </table>
                        </div>
                      </>
                    ) }
                  </Form.List>
                </div>
              </Form>
            </div>

          }



          <div className="employee-button">
            <Form.Item style={ { float: 'right' } }>
              <Button className="employee-next-button" style={ { fontWeight: 600 } } type="primary" htmlType="submit" form="otherForm" onClick={ onSaveAllData } loading={ saveloader }>
                Save
              </Button>
            </Form.Item>
            <Button className="employee-backs-button" style={ { fontWeight: 600 } } type="primary" onClick={ () => setCurrent(currentStep - 1) }>
              <span style={ { color: "#4079FC" } }>Back</span>
            </Button>
          </div>
        </Form>


      </>

    )
  }
  //-----------------
  const stepItems = [
    "Personal Info",
    "Employment",
    "Salary",
    "User",
    "Others"
  ];
  const stepFormNames = [
    createEmployee,
    createEmployment,
    "createPayroll",
    createUser,
    "othersForm"
  ];
  const referenceDataLoading = employeeDataLoading || companyDataLoading;

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return (
    <>
      <ModalComponent
        width={ 1100 }
        maskClosable={ false }
        className="create-employee-modal"
        mainTitle={
          <span className="create-employee-title">
            <strong>Create Employee</strong>
            <span>Add a new team member — 5 quick steps</span>
          </span>
        }
        visible={ true }
        onCancel={ requestCloseCreateEmployee }
        footer={ null }
      >
        <div className="create-employee-wizard">
          <div className="create-employee-steps">
            <Steps current={ currentStep } responsive={ false }>
              { stepItems.map((title, index) => (
                <Steps.Step
                  key={ title }
                  title={ title }
                  disabled={
                    (index === 1 && !employeeInfo) ||
                    (index === 2 && !employmentInfo) ||
                    (index === 3 && !employmentInfo) ||
                    (index === 4 && !userInfo)
                  }
                />
              )) }
            </Steps>
          </div>

          <div className="create-employee-scroll">
            <Spin spinning={ referenceDataLoading } tip="Loading form options..." size="large">
              <div className="create-employee-step-content">
                { currentStep === 0 ? employeeForm() : currentStep === 1 ? employeeEmploymentForm() : currentStep === 2 ? payrollSalaryForm() : currentStep === 3 ? userForm() : currentStep === 4 ? employeeOthersInfo() : '' }
              </div>
            </Spin>
          </div>

          <div className="create-employee-footer">
            <div>
              { currentStep > 0 && (
                <Button className="create-employee-back" onClick={ () => setCurrent(currentStep - 1) }>
                  ← Back
                </Button>
              ) }
            </div>
            <div className="create-employee-footer__actions">
              <Button className="create-employee-cancel" onClick={ requestCloseCreateEmployee }>
                Cancel
              </Button>
              <Button
                className="create-employee-primary"
                type="primary"
                htmlType="submit"
                form={ stepFormNames[currentStep] }
                loading={ currentStep === 4 && saveloader }
                disabled={ referenceDataLoading }
              >
                { currentStep === 4 ? "Create Employee ✓" : "Next →" }
              </Button>
            </div>
          </div>
        </div>
      </ModalComponent>

      <Modal
        open={ closePromptOpen }
        centered
        width={ 440 }
        title="Close Create Employee?"
        onCancel={ () => setClosePromptOpen(false) }
        footer={ [
          <Button key="discard" onClick={ () => closeCreateEmployee(true) }>
            Discard Draft & Close
          </Button>,
          <Button key="keep" type="primary" onClick={ () => closeCreateEmployee(false) }>
            Keep Draft & Close
          </Button>
        ] }
      >
        <p>Your entered information can be kept and restored when you open this form again.</p>
      </Modal>
    </>
  )
}

export default AddEmployee
const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
const rules = {
  uploadPhoto: [
    { required: true, message: trans(`${langKey}.uploadPhoto.required`), },
  ],
  salutation_id: [
    { required: true, message: trans(`${langKey}.salutation.required`), },
  ],
  first_name: [
    { required: true, message: trans(`${langKey}.firstName.required`), },
  ],
  last_name: [
    { required: true, message: trans(`${langKey}.lastName.required`), },
  ],
  father_or_husband_name: [
    { required: true, message: trans(`${langKey}.fatherName.required`), },
  ],
  gender_id: [
    { required: true, message: trans(`${langKey}.gender.required`), },
  ],
  d_o_b: [
    { required: true, message: trans(`${langKey}.dob.required`), },
  ],
  marital_status_id: [
    { required: true, message: trans(`${langKey}.dob.required`), },
  ],
  nationality_id: [
    { required: true, message: trans(`${langKey}.nationality.required`), },
  ],
  mobile_no: [
    { required: true, message: trans(`${langKey}.mobileNo.required`), },
  ],
  // email: [
  //   { required: true, message: trans(`${langKey}.email.required`) },
  // ],
  cnic_no: [
    { required: true, message: trans(`${langKey}.cnicNo.required`), }, { min: 13 },
  ],
  passport_no: [
    { required: true, message: trans(`${langKey}.passportNo.required`), },
  ],
  joining_date: [
    { required: true, message: trans(`${langKey}.joiningDate.required`), },
  ],
  grade_id: [
    { required: true, message: trans(`${langKey}.grade.required`), },
  ],
  location_id: [
    { required: true, message: trans(`${langKey}.location.required`), },
  ],
  department_id: [
    { required: true, message: trans(`${langKey}.department.required`), },
  ],
  branch_id: [
    { required: true, message: trans(`${langKey}.branch.required`), },
  ],
  designation_id: [
    { required: true, message: trans(`${langKey}.designation.required`), },
  ],
  jobtitle_id: [
    { required: true, message: trans(`${langKey}.jobtitle.required`), },
  ],
  linemanager_id: [
    { required: true, message: trans(`${langKey}.lineManager.required`), },
  ],
  finalauthority: [
    { required: true, message: trans(`${langKey}.finalAuthority.required`), },
  ],
  official_email: [
    { required: true, message: trans(`${langKey}.officialEmail.required`), },
  ],
  employee_type_id: [
    { required: true, message: trans(`${langKey}.employeeType.required`), },
  ],
  contracttype_id: [
    { required: true, message: trans(`${langKey}.employmentType.required`), },
  ],
  user_name: [
    { required: true, message: trans(`${langKey}.userName.required`), },
  ],
  password: [
    { required: true, message: trans(`${langKey}.password.required`), },
  ],
  passwordconfirmation: [
    { required: true, message: trans(`${langKey}.passwordConfirmation.required`), },
  ],
  timezone_id: [
    { required: true, message: trans(`${langKey}.timezone.required`), },
  ],
  role_id: [
    { required: true, message: trans(`${langKey}.role.required`), },
  ],
  probation_end_date: [
    { required: true, message: trans(`${langKey}.probationEndDate.required`), },
  ],
  contract_expiry_date: [
    { required: true, message: trans(`${langKey}.contract_expiry_date.required`), },
  ],

  payroll: [
    { required: true, message: trans(`${langKey}.payroll.required`), },
  ],
  payrollType: [
    { required: true, message: trans(`${langKey}.payrollType.required`), },
  ],
  payrollMethod: [
    { required: true, message: trans(`${langKey}.payrollMethod.required`), },
  ],
  grossSalary: [
    { required: true, message: trans(`${langKey}.grossSalary.required`), },
  ],
  policy: [
    { required: false, message: trans(`${langKey}.policy.required`), },
  ],
  complete_address: [
    { required: true, message: trans(`${langKey}.address.req`) },
  ],
  employee_id: [
    { required: true, message: trans(`${langKey}.employee.req`) },
  ],
  address_type: [
    { required: true, message: trans(`${langKey}.addresstype.req`) },
  ],

  name: [
    { required: true, message: trans(`${langKey}.name.req`) },
  ],

  relationship: [
    { required: true, message: trans(`${langKey}.select.relationship.req`) },
  ],




  contact_type: [
    { required: true, message: trans(`${langKey}.select.contact_type.req`) },
  ],
  address: [
    { required: true, message: trans(`${langKey}.address.req`) },
    {
      max: 1000, // Adjust the maximum number of characters as needed
      message: 'Max characters limit 1000 exceeded',
    },
  ],

  degree: [
    { required: true, message: trans(`${langKey}.degree.req`) },
  ],

  institute_name: [
    { required: true, message: trans(`${langKey}.institute_name.req`) },
  ],
  from_date: [
    { required: true, message: trans(`${langKey}.from_date.req`) },
  ],
  to_date: [
    { required: true, message: trans(`${langKey}.to_date.req`) },
  ],


  rel_phone_no: [
    { required: true, message: trans(`${langKey}.phone_no.req`) },
  ],

  employee_relative_id: [
    { required: true, message: trans(`${langKey}.employee_relative_id.req`) },
  ],
  undefined: [

  ],


};
